import {Api} from './utils/Api';

export const api = new Api(process.env.REACT_APP_API_URL);
